import Home from "pages/Home";
import Dashboard from "pages/Dashboard";

import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dashboard" element={<Dashboard />} />
      </Routes>
    </BrowserRouter>
  )
}

export default Router;